import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateEmploymentInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    employed: '',
    job_description: ''
  });

  useEffect(() => {
    if (christian) {
      setFormData({
        employed: christian.employed || '',
        job_description: christian.job_description || ''
      });
    }
  }, [christian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_BASE_URL}/christian/update/${christian.id}`,  // CHANGE THIS LINE
        formData
      );
      onUpdate();
    } catch (error) {
      console.error("Error updating employment info:", error);
      alert("Failed to update employment info. Check console for details.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.employed}
          </label>
          <select
            name="employed"
            value={formData.employed}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select employment status</option>
            <option value="Yes">Employed</option>
            <option value="No">Unemployed</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.job_desc}
          </label>
          <input
            type="text"
            name="job_description"
            value={formData.job_description}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateEmploymentInfo;